module.exports = "<label class=\"toggle-switch\">\n  <input type=\"checkbox\" [(ngModel)]=\"isChecked\" (change)=\"toggleSwitch()\" />\n  <span class=\"slider round\"></span>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/toggle-switch/toggle-switch.component.html
// module id = ./src/app/toggle-switch/toggle-switch.component.html
// module chunks = main